<template>
  <div :class="{ [$style['basket-total']]: true, [$style['basket-total--pending']]: pending }">
    <span :class="$style['basket-total__label']">{{ $t('checkout.basket.total') }}</span>
    <span :class="$style['basket-total__amount']">{{ amount }}</span>
    <span :class="$style['basket-total__total']">{{
      $n(price, { key: 'currency', currency: currency })
    }}</span>
  </div>
</template>

<script>
export default {
  name: 'MiniBasketTotal',
  props: {
    amount: {
      type: Number,
      default: 0,
    },
    price: {
      type: Number,
      default: 0,
    },
    currency: {
      type: String,
      default: 'EUR',
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" module>
.basket-total {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0.9375rem 1.6875rem;

  color: var(--white);
  font-family: var(--font-mono);

  background: var(--black);

  &--pending > * {
    visibility: hidden;
  }

  &__label {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      flex: 5 1 16rem;
      margin-right: 1.5rem;
    }
    // flex: 5 1 16rem;
    margin-right: 0;
  }

  &__amount {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      min-width: 6.5rem;
    }
    flex: 0 1 6rem;

    text-align: center;
  }

  &__total {
    @media screen and (min-width: map-get($grid-breakpoints, 'md')) {
      margin-right: 3.5rem;
    }
    flex-grow: 1;
    min-width: 7rem;
    margin-right: 10%;

    text-align: right;
  }
}
</style>
